// src/App.js
import React, { useState, useEffect } from 'react';
import { termsData } from './data/termsData'; // dataフォルダからインポート
import TermList from './components/TermList';   // componentsフォルダからインポート
import SearchBar from './components/SearchBar'; // componentsフォルダからインポート
import TermDetailModal from './components/TermDetailModal'; // componentsフォルダからインポート
import Header from './components/Header'
// './App.css' は不要なら削除し、代わりに index.css でグローバルスタイルを管理

// アプリのベースURL (環境に応じて変更)
const BASE_URL = "https://invest-glossary-web.vercel.app/";

function MyPageOrAppComponent({ currentTerm }) { // currentTerm は表示中の用語オブジェクトなどを想定
  let pageTitle = "投資用語集 - あなたの投資学習をサポート";
  let pageDescription = "株式投資、FX、投資信託など、投資に関する専門用語をわかりやすく解説するオンライン辞典です。";
  let ogUrl = BASE_URL;
  let canonicalUrl = BASE_URL;
  // ... 他のデフォルトmeta情報

  if (currentTerm) {
    pageTitle = `${currentTerm.term}とは？ | 投資用語集`;
    pageDescription = `${currentTerm.term}の意味、使い方、関連情報をわかりやすく解説。投資の疑問を解決します。`;
    ogUrl = `${BASE_URL}/term/${currentTerm.id}`; // 仮のURL構造
    canonicalUrl = `${BASE_URL}/term/${currentTerm.id}`;
  }

  return (
    <>
      {/* ↓↓↓ React 19の機能で直接記述 ↓↓↓ */}
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content="投資,用語集,株式,FX,投資信託,初心者,解説" />

      {/* OGPタグ */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content={currentTerm ? "article" : "website"} />
      <meta property="og:url" content={ogUrl} />
      {/* <meta property="og:image" content={currentTerm?.image || `${BASE_URL}/default-og-image.png`} /> */}
      <meta property="og:site_name" content="投資用語集" />
      <meta property="og:locale" content="ja_JP" />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
    </>
  );
}


function App() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredTerms, setFilteredTerms] = useState(termsData);
  const [selectedTerm, setSelectedTerm] = useState(null);

  useEffect(() => {
    const results = termsData.filter(term =>
      term.term.toLowerCase().includes(searchTerm.toLowerCase()) ||
      term.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      term.category.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredTerms(results);
  }, [searchTerm]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleTermClick = (term) => {
    setSelectedTerm(term);
  };

  const handleCloseModal = () => {
    setSelectedTerm(null);
  };

  return (
    <div className="min-h-screen bg-gray-100 text-gray-800 flex flex-col">
      <MyPageOrAppComponent currentTerm={selectedTerm} />
      <Header /> 
      <main className="container mx-auto px-4 py-8 flex-grow max-w-3xl mt-4"> {/* ヘッダー分のマージン調整 */}
          <div className="mb-6">
            <SearchBar searchTerm={searchTerm} onSearchChange={(e) => setSearchTerm(e.target.value)} />
          </div>
        <TermList terms={filteredTerms} onTermClick={handleTermClick} />
      </main>

      {selectedTerm && (
        <TermDetailModal term={selectedTerm} onClose={handleCloseModal} />
      )}

      <footer className="text-center py-6 border-t border-gray-200 bg-white">
        <p className="text-sm text-gray-500">&copy; {new Date().getFullYear()} 投資用語集アプリ</p>
      </footer>
    </div>
  );
}

export default App;